import { useMutation } from "@apollo/client";
import { graphql } from "gql/apollo";
import { CreateAnalyticsSearchParams } from "gql/apollo/graphql";
import { useCallback } from "react";
import { ListAnalyticsSearches } from "../queries/useListAnalyticsSearches";

export const CreateAnalyticsSearch = graphql(/* GraphQL */ `
	mutation CreateAnalyticsSearch($params: CreateAnalyticsSearchParams!) {
		createAnalyticsSearch(params: $params) {
			analytics_search {
				gid
				location_name
				updated
				search_params {
					after
					asset_set_id
					before
					relative_timestamp {
						offset
						timezone
					}
					incident_types
					keywords
					longkey
					severities
					geo_filter {
						radius_km
						geometry {
							type
							point
							polygon
						}
					}
				}
			}
			error {
				code
				message
			}
			success
		}
	}
`);

export function useCreateAnalyticsSearch() {
	const [createAnalyticsSearch] = useMutation(CreateAnalyticsSearch, {
		refetchQueries: [ListAnalyticsSearches],
	});

	const handleCreateAnalyticsSearch = useCallback(
		async (params: CreateAnalyticsSearchParams) => {
			const result = await createAnalyticsSearch({
				variables: {
					params,
				},
			});

			return {
				success: result.data?.createAnalyticsSearch.success,
				error: result.data?.createAnalyticsSearch.error,
				analyticsSearch: result.data?.createAnalyticsSearch.analytics_search,
			};
		},
		[createAnalyticsSearch]
	);

	return { handleCreateAnalyticsSearch };
}
